<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Are you sure you wish to cancel the most recent render queue ?</modal-header>
    </div>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, Go Back" confirmText="Yes, Cancel"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_cancel_renders_requests',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  data: () => ({
    error: ''
  }),
  mounted () {
  },
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.cancelRendersRequests(this.confirmId).then(() => {
        this.addNotification('success', `Renders Requests Canceled Successfully`)
        const id = this.$route.params.id
        this.getCreatives(id).then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-cancel-renders-requests.vue